import React, {Component} from 'react'
import ScrollToTop from 'react-scroll-up'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'


export default class Wrap extends Component {
  render() {
    return(
      <div>
        <Header />
        <div id="content">
         {this.props.children}
        </div>
        <Footer />
        <ScrollToTop showUnder={160}>
         <span>Top</span>
       </ScrollToTop>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Wrap.js